import React from 'react';
import StepProgressBar from '@reverbdotcom/commons/src/components/step_progress_bar';
import { core_apimessages_CheckoutPaymentMethod_Type as CheckoutPaymentMethodType } from '../../schemas/rql';
import { CONFIRMATION_STEP, CheckoutStep, PAYMENT_STEP, REVIEW_STEP, SHIPPING_STEP } from '../../lib/checkout_step';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';
import { isViaPayPal } from './paymentMethods';

interface Props {
  step: CheckoutStep;
  paymentMethodType: CheckoutPaymentMethodType;
}

const translate = withPrefix('discovery.checkout.checkoutProgressBar');

export function CheckoutProgressBar({ step, paymentMethodType }: Props) {
  return (
    <StepProgressBar
      activeStep={step}
      steps={checkoutSteps(paymentMethodType)}
    />
  );
}

function checkoutSteps(paymentMethodType: CheckoutPaymentMethodType) {
  if (isViaPayPal(paymentMethodType)) {
    return [
      {
        name: SHIPPING_STEP,
        label: translate('shipping'),
      },
      {
        name: PAYMENT_STEP,
        label: translate('paypalPayment'),
      },
      {
        name: REVIEW_STEP,
        label: translate('review'),
      },
      {
        name: CONFIRMATION_STEP,
        label: translate('confirmation'),
      },
    ];
  }

  return [
    {
      name: SHIPPING_STEP,
      label: translate('shipping'),
    },
    {
      name: PAYMENT_STEP,
      label: translate('payment'),
    },
    {
      name: CONFIRMATION_STEP,
      label: translate('confirmation'),
    },
  ];
}
